/**
 * Fixes cookie notice settings modal aria attributes.
 * @see https://wordpress.org/support/topic/settings-modal-accessibility/
 */

var settingsModal = document.querySelector('#cliSettingsPopup');

if (settingsModal) {
	var settingsLinks = document.querySelectorAll('.cli_settings_button');
	settingsLinks.forEach(function (item) {
		item.addEventListener('click', function () {
			settingsModal.setAttribute('aria-hidden', false);
		});
	});
	document.getElementById('cliModalClose').addEventListener('click', function () {
		settingsModal.setAttribute('aria-hidden', true);
	});
}

/**
 * Fix focus not restoring after clicking a button in cookie banner.
 */
var cookieButtonsContainer = document.querySelector('.cli-bar-btn_container');
var currentActiveElement = document.activeElement; // Revised when focus changes, see below.

if (cookieButtonsContainer) {
	var buttons = cookieButtonsContainer.querySelectorAll('a[role="button"]');
	buttons.forEach(function (item) {
		item.addEventListener('click', function () {
			currentActiveElement.focus();
		});
	});
}

/**
 * Monitor focus change events and store the currently focused element.
 */
document.addEventListener('focus', function () {
	currentActiveElement = document.activeElement;
}, true);
